/** @format */

import axios from "axios";
import { API_PARAMS } from "../constants/api";

const apiClient = axios.create({
  baseURL: API_PARAMS.BASE_URL,
});

export default apiClient;
